import React from "react"
import cx from "classnames"
import CONSTANTS from "@/constants/index"

function Button({
  id,
  btnRef,
  label,
  type,
  role,
  size,
  link,
  to,
  title,
  target,
  loading,
  disabled,
  outline,
  flexible,
  customClass,
  onClick,
  tabIndex,
  ariaLabel,
  ariaDescribedBy,
  icon,
  prefix,
  ariaLabelledBy,
  onKeyEnter,
  ariaDescription,
}) {
  const ButtonTag = type === "link" || (link || to) ? "a" : "button"
  const buttonClasses = cx(
    "kf-button",
    "button",
    loading ? "loading" : null,
    disabled ? "disabled" : null,
    outline ? "outline" : null,
    flexible ? "flexible" : null,
    size === "small" ? "small" : "large",
    type === "ptp" ? "ptp" : null,
    type === "primary" ? "primary" : null,
    type === "secondary" ? "secondary" : null,
    type === "delete" ? "delete" : null,
    type === "link" ? "link" : null,
    type === "email" ? "email" : null,
    type === "ghost" ? "ghost" : null,
    customClass ? customClass : null
  )

  const handleKeyDown = e => {
    if (e.key === CONSTANTS.KEY.ENTER) {
      if (disabled) {
        e.preventDefault()
      } else if (onKeyEnter) {
        onKeyEnter()
      }
    } else if (onKeyEnter) {
      onKeyEnter()
    }
  }

  return (
    <ButtonTag
      id={id}
      ref={btnRef}
      href={to || link}
      title={title}
      target={target}
      tabIndex={tabIndex}
      className={buttonClasses}
      aria-disabled={disabled}
      aria-label={ariaLabel ? ariaLabel : label}
      aria-describedby={ariaDescribedBy ?? ""}
      onClick={e => onClick && onClick(e)}
      onKeyDown={handleKeyDown}
      aria-labelledby={ariaLabelledBy ?? ""}
      aria-description={ariaDescription ?? ""}
    >
      {loading && <div className="loader"></div>}
      {prefix && <img src={prefix} className="prefix" role="presentation" />}
      <span>{label}</span>
      {icon && <img src={icon} className="icon" role="presentation" />}
    </ButtonTag>
  )
}
Button.defaultProps = {
  type: "primary",
  size: "large",
  tabIndex: 0,
}

export default Button
